<template>
  <footer>
    <div class="wrapper pt-12 pb-32 flex flex-wrap gap-8 transition-all">
      <div class="basis-[340px] flex flex-col gap-8">
        <div class="hidden sm:block">
          <img src="/stima/assets/images/logo.svg" alt="Stima">
        </div>

        <div class="font-jakarta font-regular sm:font-semibold text-sm lg:text-[16px]">
          <span>STIMA S.R.L. SM29758 © | 2021-2022 </span>
          <span>Copyright. All rights Reserved.</span>
        </div>

        <div>
          <span class="font-jakarta font-regular text-sm lg:text-[16px] text-cfgray">
            Private property is recognized and guaranteed by the law, which determines the methods of
            acquisition, enjoyment and limits, in order to ensure the social function and make it accessible to all.
          </span>
        </div>

        <div class="flex gap-6">
          <a href="#"><img src="/stima/assets/images/icons/social/meta.svg" alt="Facebook"></a>
          <a href="#"><img src="/stima/assets/images/icons/social/x.svg" alt="X"></a>
          <a href="#"><img src="/stima/assets/images/icons/social/instagram.svg" alt="Instagram"></a>
          <a href="#"><img src="/stima/assets/images/icons/social/in.svg" alt="LinkedIn"></a>
          <a href="#"><img src="/stima/assets/images/icons/social/github.svg" alt="GitHub"></a>
          <a href="#"><img src="/stima/assets/images/icons/social/tg.svg" alt="Telegram"></a>
        </div>
      </div>

      <div class="grow flex flex-wrap justify-between gap-8">
        <div class="basis-full sm:basis-1/4">
          <div class="footer-nav-item pointer-events-none text-cfgray">STIMA</div>
          <NavigationList :items="stimaItems" />
        </div>

        <div class="basis-full sm:basis-1/4">
          <div class="footer-nav-item pointer-events-none text-cfgray">Need Help?</div>
          <NavigationList :items="helpItems" />
        </div>

        <div class="basis-full sm:basis-1/4">
          <div class="footer-nav-item pointer-events-none text-cfgray">Terms & Policies</div>
          <NavigationList :items="policyItems" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import NavigationList from './components/NavigationList.vue'

const stimaItems = [
  {id: 'Traceability Network', link: '#'},
  {id: 'Artificial Intelligence', link: '#'},
  {id: 'Payment System', link: '#'},
  {id: 'STIMA Token', link: '#'},
  {id: 'Blockchain', link: '#'},
  {id: 'Minting', link: '#'},
  {id: 'Cross Property Sharing', link: '#'},
  {id: 'Exchange', link: '#'},
  {id: 'Monetary Policy', link: '#'},
  {id: 'Liquidity Pool', link: '#'},
  {id: 'AML, KYC & OFAC', link: '#'}
]

const helpItems = [
  {id: 'Customer Care', link: '#'},
  {id: 'Live Support', link: '#'},
  {id: 'FAQ', link: '#'},
  {id: 'Contacts', link: '#'},
  {id: 'Brandbook', link: '#'}
]

const policyItems = [
  {id: 'Terms and Conditions', link: '#'},
  {id: 'Privacy Policy', link: '#'}
]
</script>
